import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { fetchReview } from '../../redux/thunks';
import { loaderSelector, reviewHeaderSelector } from '../../redux/selector';
import ReviewHeaderUI from '../../../../../stories/components/cars/reviewpage/ReviewHeader/ReviewHeaderUI';
import HeaderNavigationUI from '../../../../../stories/components/cars/reviewpage/HeaderNavigation/HeaderNavigationUI';
import { loadNewPaymentsOptions } from '../../../../common/redux/payment-actions';
import { pageView } from '../../../../config/ga';
import { scrollToTop } from '../../../../config/utils';
import { fetchPageMakerAPIs, fetchGoCashInfo } from '../../../../common/redux/thunks';
import { gcBookingReviewScreen, getLoadedComponent, sendEventOnError } from '../../../../../shared/config/omni';
import { UPDATE_USER_INFO, userSelector } from '@stencil/user-reducer';
import {useProfileStore} from '@growth/auth-helpers'
import { getTravellerInformation } from '../../../Homepage/redux/thunks';

const ReviewHeader = () => {
  const dispatch = useDispatch();
  const loaders = useSelector(loaderSelector);
  const reviewHeader =  useSelector(reviewHeaderSelector);
  const userDetails = useSelector(userSelector)
  const { review = false } = loaders;
  const data = review ? {} : reviewHeader;

  const {
    userDetailsData, userDetailsFetch
  } = useProfileStore((s) => ({userDetailsData:s.data, userDetailsFetch:s.fetch }));

  const errorHandling = (err) => sendEventOnError([{
    field: `user profile info error review`,
    message: err
  }])

  useEffect(() => {
    dispatch(getTravellerInformation())
    dispatch(fetchReview()).then(() => {
      getLoadedComponent('ReviewHeader')
      setTimeout(() => {
        dispatch(pageView(gcBookingReviewScreen));
      }, 2000)
    });

    if (!userDetails?.gocashInfo?.t_amt) {
      dispatch(fetchGoCashInfo())
    }

    if (!userDetails?.userInfo?.uuid?.length) {
      userDetailsFetch({ platform:"dweb", onError:errorHandling })
    }
    scrollToTop(0, false);
    dispatch(fetchPageMakerAPIs({ isTemplates: 'cabs_dweb_review' }));
    loadNewPaymentsOptions();
  }, []);

  useEffect(() => {
    if (!userDetails?.userInfo?.uuid && userDetailsData?.uuid) {
      const userInfo = {
        first_name: userDetailsData?.firstName || "",
        last_name: userDetailsData?.lastName || "",
        email: userDetailsData?.email || "",
        profileId: userDetailsData?.profileId || "",
        profile_type: userDetailsData?.profileType || "",
        image_url: userDetailsData?.profileImage || "",
        gender: userDetailsData?.gender || "",
        uuid: userDetailsData?.uuid || ""
      }
      dispatch({
        type: UPDATE_USER_INFO,
        userInfo : userInfo || {}
      });
    }
  }, [userDetailsData, userDetails])
  
  return (
    <>
      <HeaderNavigationUI />
      <ReviewHeaderUI {...data} />
    </>
  );
}

export default ReviewHeader;